import { customerPriceGroup, customerDiscount, customerFixedPrice } from '@/lib/customerPricing';
import { lijnPrijsVan, artikelVoorVariant } from '@/lib/artikelPrijs';
import { scanPackSize, scanTotal } from '@/lib/scanQuantity';

export const canPriceScanItem = item => !!item.art_id && scanTotal(item) >= 0;

export const scanPriceVariant = (article, item) => {
  const key = item.variant_combo_key || item.variant_code;
  if (!key) return null;
  const variants = article.varianten?.length ? article.varianten : (article.variant_matrix?.rijen || []);
  const variant = variants.find(v => [v.combo_key, v.art_code, v.code].includes(key));
  if (!variant || variant.actief === false) throw new Error('Een artikelvariant is gewijzigd. Kies deze opnieuw.');
  return variant;
};

export const scanCustomerQuote = (article, variant, customer) => {
  const group = customerPriceGroup(customer);
  const fixed = customerFixedPrice(article, customer, group, variant);
  const base = variant?.prijs_override ?? article.prijzen?.[group] ?? article.prijzen?.basic ?? 0;
  const effective = artikelVoorVariant(article, variant);
  const unitPrice = fixed ?? lijnPrijsVan(effective, base);
  return { group, unitPrice, discount: fixed != null ? 0 : customerDiscount(article, customer, group, variant) };
};

export const applyScanCustomerPrice = (item, article, variant, customer) => {
  if (!canPriceScanItem(item)) return item;
  const quote = scanCustomerQuote(article, variant, customer);
  const originalSize = Number(item.artikel_pack_grootte) || scanPackSize(item);
  // A fixed customer amount is per sold unit, not per piece. Custom pack sizes
  // and additional/missing pieces retain the price of the original piece.
  const perPiece = quote.unitPrice / originalSize;
  return { ...item, prijs: perPiece * (item.prijs_per_stuk ? 1 : scanPackSize(item)),
    korting: quote.discount, korting_mode: 'percent', prijs_handmatig: false,
    klant_prijsgroep: quote.group, prijs_klant_id: customer?.id || '' };
};

export const scanCustomerNetPrice = (article, variant, customer) => {
  const quote = scanCustomerQuote(article, variant, customer);
  return quote.unitPrice * (1 - quote.discount / 100);
};